import { uiTheme as t } from 'Components/ui';
import styled from 'styled-components';

export const ContainerTable = styled.div`
  margin: auto;
  width: 98%;
`;

export const TitleCell = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`;

export const PeriodNote = styled.span<{ urgent: boolean }>`
  color: ${({ urgent }) => (urgent ? t.color.danger : t.color.muted)};
  font-size: clamp(0.75rem, 1vw, 0.8125rem);
  line-height: 1.35;
  overflow-wrap: anywhere;
`;
